import { startsWith } from 'ramda';
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { logConfiguration } from 'yeself-common/BrowserUtils';

import log from 'yeself-client-common/utils/LogUtils';
import { onErrorMonitor } from 'yeself-client-common/utils/SagaUtils';

import getRootReducer from 'Console/data/reducer';
import rootSaga from 'Console/data/saga';

const logConfig = logConfiguration();

const loggerOptions = {
    level: 'debug',
    collapsed: true,
    predicate: (getState, action) => !startsWith('REDUX_STORAGE', action.type),
};

export const history = createBrowserHistory();
const rootReducer = getRootReducer(history);

export const persistedReducer = persistReducer(
    { storage, key: 'yeself-console', keyPrefix: '', whitelist: ['language'] },
    rootReducer
);

const setupReduxDevToolsEnhancer = (name) =>
    // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__
        ? // eslint-disable-next-line no-underscore-dangle
          window.__REDUX_DEVTOOLS_EXTENSION__({
              name,
          })
        : (args) => args;

const configureStore = () => {
    const sagaMiddleware = createSagaMiddleware({
        onError: log.error,
        sagaMonitor: { effectRejected: onErrorMonitor },
    });
    const store = createStore(
        persistedReducer,
        compose(
            applyMiddleware(
                routerMiddleware(history), // for dispatching history actions
                sagaMiddleware,
                ...(logConfig.debug ? [createLogger(loggerOptions)] : [])
            ),
            setupReduxDevToolsEnhancer('yeself-client-console')
        )
    );

    sagaMiddleware.run(rootSaga);

    const persistor = persistStore(store);

    return { store, persistor, history };
};

export default configureStore;
